import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteAccountGroupsRequestModel, DeleteAccountGroupsResponseModel } from "@/features/accounts/account-group/services/delete-account-groups-model";

export class DeleteAccountGroupsApi {
  /**
   * 口座グループ削除
   */
  public deleteAccountGroup = async (
    param: DeleteAccountGroupsRequestModel
  ): Promise<DeleteAccountGroupsResponseModel> => {
    const path = `/api/accountgroups`;
    const res = await ApiClient.instance.delete<DeleteAccountGroupsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
